import request from "@/axios.js";

export default class FlexibleMission {
	constructor() {
    }
    /**
     * Get all flexible missions
     * @returns {Promise}
     */
	static async getAll(){
        return new Promise((resolve, reject) => {
            request
			.get("mission/getAllFlexibleMissionsNotif")
			.then(response => {
				
				resolve(response.data);
			}).catch(err => {
				reject(err);
				//console.log(err);
			});
        });
		
	}

}
